import { createPromiseAction } from 'redux-saga-promise-actions';
import { SetCustomerPayload } from 'store/types/setCustomer';

export const applySetCustomer = createPromiseAction(
  'SET_CUSTOMER_CODE',
  'SET_CUSTOMER_CONFIRM',
  'SET_CUSTOMER_NOT_CONFIRMED',
)<SetCustomerPayload, undefined, undefined>();
